"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace = 'raydiant';
var IFrameRenderer = /** @class */ (function () {
    function IFrameRenderer(container) {
        var _this = this;
        this.container = container;
        this.windows = {};
        this.globalMessageHandler = function (event) {
            // Ignore messages that don't start with the message prefix.
            if (typeof event.data === 'string' && event.data.startsWith(namespace)) {
                var _a = _this.deserializeMessage(event.data), windowId = _a.windowId, type = _a.type, payload = _a.payload;
                if (!windowId || !type) {
                    console.warn("Invalid message received from child window '".concat(event.data, "'"));
                    return;
                }
                var window_1 = _this.getWindow(windowId);
                if (!window_1) {
                    throw new Error("Failed add receive message callback to window, window with window id: '".concat(windowId, "' was not found"));
                }
                if (window_1.receiveMessageCallback) {
                    window_1.receiveMessageCallback(type, payload);
                }
            }
        };
        // Post message is a single channel for all window so we need to
        // attach a global message handler that forwards the event to the
        // correct window.
        window.addEventListener('message', this.globalMessageHandler, false);
    }
    IFrameRenderer.prototype.createWindow = function (_a) {
        var windowId = _a.windowId, bounds = _a.bounds, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'black' : _b, receiveMessageCallback = _a.receiveMessageCallback;
        return __awaiter(this, void 0, void 0, function () {
            var frame;
            return __generator(this, function (_c) {
                frame = document.createElement('iframe');
                this.windows[windowId] = { frame: frame, receiveMessageCallback: receiveMessageCallback };
                frame.setAttribute('data-windowId', windowId);
                // Set the allowed permissions for the iframe.
                // * allows any loaded domain to have access, which is required for
                // third-party sites loaded into the iframe.
                frame.allow = 'microphone *; camera *; autoplay';
                // Default styles.
                frame.style.position = 'absolute';
                frame.style.zIndex = '0';
                frame.style.border = 'none';
                // Position will be 0,0 for the main window.
                if (bounds) {
                    frame.style.top = "".concat(bounds.y, "px");
                    frame.style.left = "".concat(bounds.x, "px");
                    frame.style.width = "".concat(bounds.width, "px");
                    frame.style.height = "".concat(bounds.height, "px");
                }
                else {
                    // If bounds assume fullscreen.
                    frame.style.top = '0px';
                    frame.style.left = '0px';
                    frame.style.width = '100%';
                    frame.style.height = '100%';
                }
                if (backgroundColor) {
                    frame.style.backgroundColor = backgroundColor;
                }
                // Set initial visibility and send to background.
                frame.style.zIndex = '0';
                frame.style.visibility = 'hidden';
                this.container.appendChild(frame);
                return [2 /*return*/];
            });
        });
    };
    IFrameRenderer.prototype.loadWindow = function (windowId, url) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to update window bounds, missing window id '".concat(windowId, "'"));
        }
        // Return a promise that resolves then the window has successfully loaded.
        return new Promise(function (resolve, reject) {
            window.frame.onload = function () {
                resolve();
            };
            window.frame.onerror = function () {
                reject(new Error("Error loading window for '".concat(url, "'")));
            };
            window.frame.src = url;
        });
    };
    IFrameRenderer.prototype.updateWindowBounds = function (windowId, bounds) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to update window bounds, missing window id '".concat(windowId, "'"));
        }
        window.frame.style.top = "".concat(bounds.y, "px");
        window.frame.style.left = "".concat(bounds.x, "px");
        window.frame.style.width = "".concat(bounds.width, "px");
        window.frame.style.height = "".concat(bounds.height, "px");
    };
    IFrameRenderer.prototype.showWindow = function (windowId, isFocused) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to show window, missing window id '".concat(windowId, "'"));
        }
        window.frame.style.zIndex = '9999';
        window.frame.style.visibility = 'visible';
        if (isFocused) {
            window.frame.focus();
        }
    };
    IFrameRenderer.prototype.hideWindow = function (windowId) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to hide window, missing window id '".concat(windowId, "'"));
        }
        window.frame.style.zIndex = '0';
        window.frame.style.visibility = 'hidden';
    };
    IFrameRenderer.prototype.removeWindow = function (windowId) {
        return __awaiter(this, void 0, void 0, function () {
            var window;
            return __generator(this, function (_a) {
                window = this.getWindow(windowId);
                if (!window) {
                    throw new Error("Failed to remove window, missing window id '".concat(windowId, "'"));
                }
                this.container.removeChild(window.frame);
                delete this.windows[windowId];
                return [2 /*return*/];
            });
        });
    };
    IFrameRenderer.prototype.sendMessageString = function (windowId, message) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to send message '".concat(message, "', missing window id '").concat(windowId, "'"));
        }
        if (!window.frame.contentWindow) {
            throw new Error("Failed to send message '".concat(message, "', contentWindow missing for '").concat(windowId, "'"));
        }
        window.frame.contentWindow.postMessage("".concat(namespace, ":").concat(message), '*');
    };
    IFrameRenderer.prototype.sendMessageObject = function (windowId, type, payload) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to send message '".concat(type, "', missing window id '").concat(windowId, "'"));
        }
        if (!window.frame.contentWindow) {
            throw new Error("Failed to send message '".concat(type, "', contentWindow missing for '").concat(windowId, "'"));
        }
        window.frame.contentWindow.postMessage({ namespace: namespace, windowId: windowId, type: type, payload: payload }, '*');
    };
    IFrameRenderer.prototype.muteWindow = function (windowId) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to mute window, missing window id '".concat(windowId, "'"));
        }
        // There is no mute/unmute API for iframes so we rely on the window manager overriding any
        // mute presentation properties.
    };
    IFrameRenderer.prototype.unMuteWindow = function (windowId) {
        var window = this.getWindow(windowId);
        if (!window) {
            throw new Error("Failed to unmute window, missing window id '".concat(windowId, "'"));
        }
        // There is no  mute/unmute API for iframes so we rely on the window manager overriding any
        // mute presentation properties.
    };
    IFrameRenderer.prototype.destroy = function () {
        window.removeEventListener('message', this.globalMessageHandler, false);
    };
    IFrameRenderer.prototype.getWindow = function (windowId) {
        return this.windows[windowId];
    };
    IFrameRenderer.prototype.deserializeMessage = function (message) {
        var _a;
        var windowId = '';
        var type = '';
        var payload;
        var json = message.replace('raydiant:', '');
        try {
            // Messages are sent as json in the format of { type: string, payload: unknown }.
            (_a = JSON.parse(json), windowId = _a.windowId, type = _a.type, payload = _a.payload);
        }
        catch (err) {
            // Not a valid message, return empty type and payload.
        }
        return { windowId: windowId, type: type, payload: payload };
    };
    return IFrameRenderer;
}());
exports.default = IFrameRenderer;
